import React from 'react';
import Card from '@/components/ui/Card';
import {
  StyledHeaderWrapper,
  StyledInfoIcon,
  StyledInquiryDetails,
  StyledInquiryDetailsContent,
  StyledInquiryDetailsContentWrapper,
  StyledInquiryDetailsWrapper,
  StyledInquiryInformation,
  StyledInquiryServiceIcon,
  StyledInquiryWrapper,
} from '@/components/ui/ForMoreInquiry/ForMoreInquiry.styled.ts';
import QueryIcon from '@/assets/icons/QueryIcon.svg';
import EmailIcon from '@/assets/icons/EmailIcon.svg';
import whatsappIcon from '@/assets/icons/whatsappIcon.svg';

const ForMoreInquiry: React.FunctionComponent = () => {
  return (
    <Card
      accent={true}
      margin={{
        top: '1.25rem',
        bottom: '1.25rem',
      }}
      padding={{
        top: '0.625rem',
        left: '0.625rem',
        bottom: '0.825rem',
        right: '0.625rem',
      }}
    >
      <StyledInquiryWrapper>
        <StyledInquiryDetails>
          <StyledHeaderWrapper>
            <StyledInquiryDetailsContent $heading>CONTACT US</StyledInquiryDetailsContent>
            <StyledInfoIcon height={50} width={50} src={QueryIcon} alt={'query-icons'} />
          </StyledHeaderWrapper>
          <StyledInquiryDetailsContentWrapper>
            <StyledInquiryDetailsWrapper>
              <StyledInquiryServiceIcon
                src={whatsappIcon}
                height={16}
                width={16}
                alt={'phone-icons'}
              />
              <div>
                For Inquiry:&nbsp;
                <StyledInquiryInformation href={'https://wa.me/9779856052581'}>
                  9856052581
                </StyledInquiryInformation>
              </div>
            </StyledInquiryDetailsWrapper>
            <StyledInquiryDetailsWrapper>
              <StyledInquiryServiceIcon
                src={whatsappIcon}
                height={16}
                width={16}
                alt={'phone-icons'}
              />
              <div>
                For Technical Issue:&nbsp;
                <StyledInquiryInformation href={'https://wa.me/9846511962'}>
                  9846511962
                </StyledInquiryInformation>
              </div>
            </StyledInquiryDetailsWrapper>
            <StyledInquiryDetailsContentWrapper>
              {/* Email Icon */}
              <StyledInquiryDetailsWrapper>
                <StyledInquiryServiceIcon
                  src={EmailIcon}
                  height={15}
                  width={15}
                  alt={'email-icons'}
                />
                Email:
                {/* Email Address Number */}
                <StyledInquiryInformation href={'mailto://contact@revelarena.com'}>
                  contact@revelarena.com
                </StyledInquiryInformation>
              </StyledInquiryDetailsWrapper>
            </StyledInquiryDetailsContentWrapper>
          </StyledInquiryDetailsContentWrapper>
        </StyledInquiryDetails>
      </StyledInquiryWrapper>
    </Card>
  );
};

export default ForMoreInquiry;
